$(document).ready(function() {

	let menuToggle     = $('.hamburger');
	let frontEndNav    = $('.site-navigation');
	let backEndNav     = $('.side-menu-wrapper');
	
	menuToggle.click(function() {
		$(this).toggleClass('open');
		if ($('body').hasClass('admin-panel')) {
			backEndNav.slideToggle(250).toggleClass('open');
		} else {
			frontEndNav.slideToggle(250).toggleClass('open');
		}
		
	});
	
});